import React, { useState } from 'react';
import SvgIcons from '../../../../../services/SvgIcons';
import './ResetPasswordForm.scss';
import { checkCapital, checkDigit, checkLowercase, checkSpecialCharacter } from '../../../../../services/inputCheck';
import { strapiAuthService } from '../../../../../services/api/strapiAuth';

const ResetPasswordForm = ({ resetToken, onSuccess }) => {
    const [formData, setFormData] = useState({
        resetToken: resetToken,
        newPassword: '',
        confirmPassword: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        /* newPassword: '',
        confirmPassword: '', */
        general: ''
    });

    const [hasGoodLength, setHasGoodLength] = useState(false);
    const [hasCapitalLetter, setHasCapitalLetter] = useState(false);
    const [hasLowercaseLetter, setHasLowercaseLetter] = useState(false);
    const [hasDigit, setHasDigit] = useState(false);
    const [hasSpecialCharacter, setHasSpecialCharacter] = useState(false);
    const [passwordsMatch, setPasswordsMatch] = useState(false);
    const [enabledValidateBtn, setEnabledValidateBtn] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        // Validation en temps réel
        if (name === 'newPassword') {
            e.target.value.length >= 8 && e.target.value.length <= 20 ? setHasGoodLength(true) : setHasGoodLength(false);
            checkCapital(e.target.value) ? setHasCapitalLetter(true) : setHasCapitalLetter(false);
            checkLowercase(e.target.value) ? setHasLowercaseLetter(true) : setHasLowercaseLetter(false);
            checkDigit(e.target.value) ? setHasDigit(true) : setHasDigit(false);
            checkSpecialCharacter(e.target.value) ? setHasSpecialCharacter(true) : setHasSpecialCharacter(false);
        }

        if (name === 'newPassword' || name === 'confirmPassword') {
            if ( value !== '') {
                setPasswordsMatch(formData.newPassword === value || formData.confirmPassword === value);
                setEnabledValidateBtn(hasGoodLength && hasCapitalLetter && hasLowercaseLetter && hasDigit && hasSpecialCharacter && (formData.newPassword === value || formData.confirmPassword === value))
            }
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        // Validation des champs    
        if (!hasGoodLength || !hasCapitalLetter || !hasLowercaseLetter || !hasDigit || !hasSpecialCharacter || !passwordsMatch) {
            setLoading(false);
            return;
        }

        try {
            await strapiAuthService.resetPassword(formData);
            onSuccess();
        } catch (err) {
            setErrors(prev => ({
                ...prev,
                general: err.message || 'Une erreur est survenue. Veuillez réessayer.'
            }));
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    return (
        <div className="reset-password-form__container">
            <h1>Réinitialiser le mot de passe</h1>
            <div className='reset-password-form__rules_container'>
                <div className='reset-password-form__rule_container'>
                    <SvgIcons
                        name={hasGoodLength ? 'check_circle_fill' : 'empty_circle'}
                        width="20"
                        height="20"
                        color={hasGoodLength ? "#096e48" : "#36152F"}
                    />
                    <p className='reset-password-form__rules_require'>Le mot de passe doit contenir entre 8 et 20 caractères</p>
                </div>
                <div className='reset-password-form__rule_container'>
                    <SvgIcons
                        name={hasLowercaseLetter ? 'check_circle_fill' : 'empty_circle'}
                        width="20"
                        height="20"
                        color={hasLowercaseLetter ? "#096e48" : "#36152F"}
                    />
                    <p className='reset-password-form__rules_require'>Le mot de passe doit contenir au moins une lettre minuscule</p>
                </div>
                <div className='reset-password-form__rule_container'>
                    <SvgIcons
                        name={hasCapitalLetter ? 'check_circle_fill' : 'empty_circle'}
                        width="20"
                        height="20"
                        color={hasCapitalLetter ? "#096e48" : "#36152F"}
                    />
                    <p className='reset-password-form__rules_require'>Le mot de passe doit contenir au moins une lettre majuscule</p>
                </div>
                <div className='reset-password-form__rule_container'>
                    <SvgIcons
                        name={hasDigit ? 'check_circle_fill' : 'empty_circle'}
                        width="20"
                        height="20"
                        color={hasDigit ? "#096e48" : "#36152F"}
                    />
                    <p className='reset-password-form__rules_require'>Le mot de passe doit contenir au moins un chiffre</p>
                </div>
                <div className='reset-password-form__rule_container'>
                    <SvgIcons
                        name={hasSpecialCharacter ? 'check_circle_fill' : 'empty_circle'}
                        width="20"
                        height="20"
                        color={hasSpecialCharacter ? "#096e48" : "#36152F"}
                    />
                    <p className='reset-password-form__rules_require'>Le mot de passe doit contenir au moins un caractère spécial</p>
                </div>
                <div className='reset-password-form__rule_container'>
                    <SvgIcons
                        name={passwordsMatch ? 'check_circle_fill' : 'empty_circle'}
                        width="20"
                        height="20"
                        color={passwordsMatch ? "#096e48" : "#36152F"}
                    />
                    <p className='reset-password-form__rules_require'>Les mots de passe sont identiques</p>
                </div>
            </div>
            <form className="reset-password-form" onSubmit={handleSubmit}>
                <div className="reset-password-form__input-group">
                    <label htmlFor="password">Nouveau mot de passe</label>
                    <div className="reset-password-form__password-input">
                        <input
                            id="newPassword"
                            type={showPassword ? 'text' : 'password'}
                            name="newPassword"
                            value={formData.newPassword}
                            onChange={handleChange}
                            /* className={errors.newPassword ? 'error' : ''} */
                            required
                            placeholder="Ton nouveau mot de passe"
                        />
                        <button
                            type="button"
                            tabIndex="-1"
                            onClick={togglePasswordVisibility}
                            className="reset-password-form__toggle-password"
                            aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                        >
                            <SvgIcons
                                name={showPassword ? 'eye' : 'eye-off'}
                                width="24"
                                height="24"
                                color="#36152F"
                            />
                        </button>
                    </div>
                    {/* {errors.newPassword && (
                        <span className="login-form__error-message">
                            {errors.newPassword}
                        </span>
                    )} */}
                </div>

                <div className="reset-password-form__input-group">
                    <label htmlFor="confirmPassword">Confirmation du mot de passe</label>
                    <div className="reset-password-form__password-input">
                        <input
                            id="confirmPassword"
                            type={showConfirmPassword ? 'text' : 'password'}
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            /* className={errors.confirmPassword ? 'error' : ''} */
                            required
                            placeholder="Confirme ton mot de passe"
                        />
                        <button
                            type="button"
                            tabIndex="-1"
                            onClick={toggleConfirmPasswordVisibility}
                            className="reset-password-form__toggle-password"
                            aria-label={showConfirmPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                        >
                            <SvgIcons
                                name={showConfirmPassword ? 'eye' : 'eye-off'}
                                width="24"
                                height="24"
                                color="#36152F"
                            />
                        </button>
                    </div>
                    {/* {errors.confirmPassword && (
                        <span className="login-form__error-message">
                            {errors.confirmPassword}
                        </span>
                    )} */}
                </div>

                {errors.general && (
                    <div className="reset-password-form__error">
                        {errors.general}
                    </div>
                )}

                <button
                    type="submit"
                    className="reset-password-form__submit"
                    disabled={loading || !enabledValidateBtn}
                >
                    {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
                </button>
            </form>
        </div>
    );
};

export default ResetPasswordForm;